const WithdrawalPill = ({ status }) => {
  return (
    <p className={`px-2 py-1 w-28 rounded-full text-center font-bold ${status === 1 ? 'text-green-700 bg-green-200' : 'text-orange-700 bg-orange-200'}`}>
      {status === 1 ? 'Paid' : 'Not Paid'}
    </p>
  );
};

export default WithdrawalPill;
